// extracted by mini-css-extract-plugin
module.exports = {"o-alert-section":"ActivityModalFooter_o-alert-section__2S8eE"};